import React from 'react';
import tournamentService from '../../services/tournamentService';

const TournamentOverview = ({ tournament, leaderboardStats }) => {
  // Helper function to format date as mm/dd/yyyy
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const {
    totalSkins = 0,
    totalSawoffs = 0,
    skinWinners = [],
    sawOffWinners = []
  } = leaderboardStats || {};

  const renderWinnerList = (winners, emptyLabel) => {
    if (!winners || winners.length === 0) {
      return (
        <div
          style={{
            color: 'var(--text-secondary)',
            fontSize: 'var(--font-size-sm)'
          }}
        >
          {emptyLabel}
        </div>
      );
    }

    return winners.slice(0, 5).map((winner) => {
      const key = winner.playerId || winner.playerName;
      const events = Array.isArray(winner.events) ? winner.events : [];
      const displayedEvents = events.slice(0, 6);
      const hasOverflow = events.length > displayedEvents.length;

      return (
        <div
          key={key}
          style={{
            marginBottom: 'var(--spacing-sm)',
            paddingBottom: 'var(--spacing-xs)',
            borderBottom: '1px solid var(--border-primary)'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 'var(--spacing-sm)'
            }}
          >
            <span
              style={{
                fontWeight: 600,
                color: 'var(--text-primary)'
              }}
            >
              {winner.playerName}
            </span>
            <span
              style={{
                backgroundColor: 'var(--bg-tertiary)',
                borderRadius: 'var(--radius-sm)',
                padding: '0 var(--spacing-sm)',
                fontSize: 'var(--font-size-sm)',
                fontWeight: 600,
                color: 'var(--text-primary)'
              }}
            >
              ×{winner.count}
            </span>
          </div>
          {displayedEvents.length > 0 && (
            <div
              style={{
                marginTop: 'var(--spacing-xs)',
                fontSize: 'var(--font-size-sm)',
                color: 'var(--text-secondary)'
              }}
            >
              {displayedEvents.join(', ')}
              {hasOverflow && '…'}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="overview-grid">
      {/* Tournament Info */}
      <div className="tournament-info-card">
        <h3 className="tournament-info-title">Tournament Information</h3>
        <div className="info-grid">
          <div className="info-item">
            <div className="info-label">Prize Pool:</div>
            <div className="info-value">{tournamentService.formatCurrency(tournament.potSize)}</div>
          </div>
          <div className="info-item">
            <div className="info-label">Max Golfers:</div>
            <div className="info-value">{tournament.maxPlayers || 'Unlimited'}</div>
          </div>
          <div className="info-item">
            <div className="info-label">Start Date:</div>
            <div className="info-value">{formatDate(tournament.startDate)}</div>
          </div>
          <div className="info-item">
            <div className="info-label">End Date:</div>
            <div className="info-value">{formatDate(tournament.endDate)}</div>
          </div>
        </div>
      </div>

      {/* Tournament Stats */}
      <div className="tournament-info-card">
        <h3 className="tournament-info-title">Tournament Statistics</h3>
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-number stat-primary">
              {tournament._count?.players || 0}
            </div>
            <div className="stat-label">Golfers</div>
          </div>
          <div className="stat-item">
            <div className="stat-number stat-success">
              {tournament._count?.bets || 0}
            </div>
            <div className="stat-label">Bets</div>
          </div>
          <div className="stat-item">
            <div className="stat-number stat-warning">
              {totalSkins}
            </div>
            <div className="stat-label">Total Skins</div>
          </div>
          <div className="stat-item">
            <div className="stat-number stat-danger">
              {totalSawoffs}
            </div>
            <div className="stat-label">Total Saw-off</div>
          </div>
        </div>
      </div>

      {(skinWinners.length > 0 || sawOffWinners.length > 0) && (
        <div className="tournament-info-card">
          <h3 className="tournament-info-title">Scoring Highlights</h3>
          <div
            style={{
              display: 'grid',
              gap: 'var(--spacing-lg)',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))'
            }}
          >
            <div>
              <h4
                style={{
                  marginBottom: 'var(--spacing-sm)',
                  fontSize: 'var(--font-size-lg)',
                  fontWeight: 600
                }}
              >
                Skin Winners
              </h4>
              {renderWinnerList(skinWinners, 'No skins have been recorded yet.')}
            </div>
            <div>
              <h4
                style={{
                  marginBottom: 'var(--spacing-sm)',
                  fontSize: 'var(--font-size-lg)',
                  fontWeight: 600
                }}
              >
                Saw-off Winners
              </h4>
              {renderWinnerList(sawOffWinners, 'No saw-offs have been recorded yet.')}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default TournamentOverview;
